import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Playlist } from '@app/library/models/playlist.model';
import {
  DuplicatePlaylistFailure,
  DuplicatePlaylistRequest,
  DuplicatePlaylistSuccess,
} from '@app/library/states/playlists.actions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { InputColorPickerComponent } from '@radioking/ui/input-color-picker';
import { Observable, Subscription } from 'rxjs';

interface DataInput {
  playlist: Playlist;
}
@Component({
  selector: 'rk-duplicate-playlist-modal',
  templateUrl: './duplicate-playlist-modal.component.html',
  styleUrls: ['./duplicate-playlist-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DuplicatePlaylistModalComponent implements OnInit, OnDestroy {
  duplicatePlaylistForm: UntypedFormGroup;

  isLoading$: Observable<boolean>;
  subscription = new Subscription();

  constructor(
    public readonly dialogRef: MatDialogRef<DuplicatePlaylistModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dataIn: DataInput,
    private readonly actions$: Actions,
    private readonly uiStore: UiStoreHelperService,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.uiStore.getLoadingState(DuplicatePlaylistRequest, [
      DuplicatePlaylistSuccess,
      DuplicatePlaylistFailure,
    ]);
    this.duplicatePlaylistForm = new UntypedFormBuilder().group({
      playlistName: [this.dataIn.playlist.name, Validators.required],
    });
    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(DuplicatePlaylistSuccess))
        .subscribe(() => this.dialogRef.close()),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @Dispatch()
  onSubmit = () => {
    const dupPlaylist: Playlist = {
      ...this.dataIn.playlist,
      name: this.duplicatePlaylistForm.value.playlistName,
      color: InputColorPickerComponent.getRandomColor(),
    };

    return new DuplicatePlaylistRequest(dupPlaylist);
  };

  onCancel() {
    this.dialogRef.close(false);
  }
}
